module.exports = [
  {
    text: "English",
    value: "en",
  },
  {
    text: "Spanish",
    value: "es",
  },
];

